<template>
    <div class="sector-edit-wrapper">
        <form autocomplete="off" method="post" data-vv-scope="form" @keyup.enter="() => {return false;}" @submit.prevent="() => {return false;}">
            <div class="row details_adding">
                <div class="col-12 col-sm edit-sector-details">
                    <div class="edit-sector-form">
                        <div class="row">
                            <div class="col-12 col-sm-7 col-lg-5">
                                <div class="form-group">
                                    <MaterialSelect
                                        :disabled="readonlyForm"
                                        class="city-form-group city-bg"
                                        id="input-cemetery"
                                        name="cemetery"
                                        label="name"
                                        v-model.trim="form.cemetery_id"
                                        :options="cemeteries"
                                        v-validate="rulesField('cemetery_id', {required: true})"
                                        :data-vv-scope="vScope"
                                        :inputClasses="[{'is-invalid': fnHasError('cemetery', vScope)}]"
                                        :error="fnFirstError('cemetery', vScope)">
                                        {{ $t(`${modelTranslateID}.cemetery`) }}
                                    </MaterialSelect>
                                </div>
                            </div>
                            <div class="col-12 col-sm-5 col-lg-3">
                                <div class="form-group">
                                    <MaterialInput
                                        :readonly="readonlyForm"
                                        :disabled="readonlyForm"
                                        class="city-form-group city-bg"
                                        id="input-number"
                                        name="number"
                                        v-model.trim="form.number"
                                        v-validate="rulesField('number', {required: true})"
                                        :data-vv-scope="vScope"
                                        :inputClasses="[{'is-invalid': fnHasError('number', vScope) }]"
                                        :error="fnFirstError('number', vScope)">
                                        {{ $t(`${modelTranslateID}.number`) }}
                                    </MaterialInput>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-lg-4">
                                <div class="form-group">
                                    <MaterialInput
                                        :readonly="true"
                                        :disabled="true"
                                        class="city-form-group city-bg"
                                        id="input-code"
                                        name="code"
                                        :value="form.code">
                                        {{ $t(`${modelTranslateID}.code`) }}
                                    </MaterialInput>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6 col-lg-4">
                                <div class="form-group">
                                    <MaterialSelect
                                        :disabled="readonlyForm"
                                        class="city-form-group city-bg"
                                        id="input-sector_type"
                                        name="sector_type"
                                        label="name"
                                        v-model.trim="form.sector_type_id"
                                        :options="types"
                                        v-validate="rulesField('sector_type_id', {required: true})"
                                        :data-vv-scope="vScope"
                                        :inputClasses="[{'is-invalid': fnHasError('sector_type', vScope)}]"
                                        :error="fnFirstError('sector_type', vScope)">
                                        {{ $t(`${modelTranslateID}.sector_type`) }}
                                    </MaterialSelect>
                                </div>
                            </div>
                            <div class="col-12 col-sm-4 col-lg-3">
                                <div class="form-group">
                                    <MaterialInput
                                        :readonly="true"
                                        :disabled="true"
                                        class="city-form-group city-bg"
                                        id="input-area"
                                        name="area"
                                        :value="form.area">
                                        {{ $t(`${modelTranslateID}.area`) }}
                                    </MaterialInput>
                                </div>
                            </div>
                            <div class="col-12 col-sm-4 col-lg-3">
                                <div class="form-group">
                                    <MaterialInput
                                        :readonly="true"
                                        :disabled="true"
                                        class="city-form-group city-bg"
                                        id="input-perimeter"
                                        name="perimeter"
                                        :value="form.perimeter">
                                        {{ $t(`${modelTranslateID}.perimeter`) }}
                                    </MaterialInput>
                                </div>
                            </div>
                            <div class="col-12 col-sm-auto align-self-center form-group">
                                <div class="form-check city-form-check form-check-inline">
                                    <input
                                        :readonly="readonlyForm"
                                        :disabled="readonlyForm"
                                        class="city-form-group city-bg"
                                        type="checkbox"
                                        id="input-status"
                                        name="status"
                                        v-model.trim="form.status"
                                        :false-value="false"
                                        :true-value="true"
                                    />
                                    <label
                                        class="form-check-label h-auto"
                                        :for="`input-status`"
                                    >
                                        <div class="d-flex flex-column align-items-start">
                                            <strong> {{ $t(`${modelTranslateID}.status`) }}</strong>
                                        </div>
                                    </label>
                                </div>
                            </div>

                            <div class="col-12 col-sm-12">
                                <div class="form-group">
                                    <MaterialTextarea
                                        :readonly="readonlyForm"
                                        :disabled="readonlyForm"
                                        class="city-form-group city-bg"
                                        :id="`input-obs`"
                                        :name="`obs`"
                                        :rows="3"
                                        v-model.trim="form.obs"
                                        v-validate="rulesField('obs')"
                                        :data-vv-scope="vScope"
                                        :inputClasses="[{'is-invalid': fnHasError(`obs`, vScope) }]"
                                        :error="fnFirstError(`obs`, vScope)">
                                        {{ $t(`${modelTranslateID}.obs`) }}
                                    </MaterialTextarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import FormMixin from "./mixins/FormMixin";

export default {
    mixins: [
        FormMixin
    ],
    props: {
        cemeteries: {
            type: Array,
            default: () => {return [];},
        },
        types: {
            type: Array,
            default: () => {return [];},
        },
    },
    data() {
        let idPanel = 'sector';
        return {
            idPanel: idPanel,
        }
    },
    computed: {
        cemetery() {
            return this.form.cemetery_id ? this.cemeteries.find(x => x.id == this.form.cemetery_id) : null;
        },
        cemeteryCode() {
            return this.cemetery?.code ?? null;
        },
        sectorNumber() {
            return this.form?.number;
        },
    },
    methods: {
        // updateCode() {
        //     this.form.code = this.$t(`${this.translateID}.form.code_template`, {cemetery: this.cemeteryCode, number: this.sectorNumber});
        // }
    },
    watch: {
        // cemetery: {
        //     immediate: false,
        //     handler: function(value) {
        //         this.updateCode();
        //     }
        // },
        // sectorNumber: {
        //     immediate: false,
        //     handler: function(value) {
        //         this.updateCode();
        //     }
        // },
    }
}
</script>

<style lang="scss" scoped>

</style>